export const BRAND_AWARENESS = [
  'Email',
  'Facebook',
  'Family & Friends',
  'TV / Radio',
  'Internet',
  'Other'
];
